"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressNoncesToJSON = exports.AddressNoncesFromJSONTyped = exports.AddressNoncesFromJSON = void 0;
function AddressNoncesFromJSON(json) {
    return AddressNoncesFromJSONTyped(json, false);
}
exports.AddressNoncesFromJSON = AddressNoncesFromJSON;
function AddressNoncesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'last_mempool_tx_nonce': json['last_mempool_tx_nonce'],
        'last_executed_tx_nonce': json['last_executed_tx_nonce'],
        'possible_next_nonce': json['possible_next_nonce'],
        'detected_missing_nonces': json['detected_missing_nonces'],
    };
}
exports.AddressNoncesFromJSONTyped = AddressNoncesFromJSONTyped;
function AddressNoncesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'last_mempool_tx_nonce': value.last_mempool_tx_nonce,
        'last_executed_tx_nonce': value.last_executed_tx_nonce,
        'possible_next_nonce': value.possible_next_nonce,
        'detected_missing_nonces': value.detected_missing_nonces,
    };
}
exports.AddressNoncesToJSON = AddressNoncesToJSON;
//# sourceMappingURL=AddressNonces.js.map